import { searchContext } from '../../../../context/Context';

export function ScoreHeader() {
  const { tab } = searchContext();

  return tab === 'GDA' ? (
    <>
      <span title="Gene-Disease Association Score">
        Score<sub>gda</sub>
      </span>
    </>
  ) : (
    <span title="Variant-Disease Association Score">
      Score<sub>vda</sub>
    </span>
  );
}
